import React, { Component } from "react";
import { hot } from "react-hot-loader";
import firebase from "firebase";
import { FilePond, registerPlugin } from "react-filepond";

import "filepond/dist/filepond.min.css";
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImageResize from "filepond-plugin-image-resize";
import FilePondPluginImageTransform from "filepond-plugin-image-transform";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import { Button, Box, AppBar } from "@material-ui/core";
import { createPlaceholderFile } from "../../utils/files";

// Register the plugins
registerPlugin(
  // FilePondPluginImageExifOrientation,
  // FilePondPluginImageTransform,
  // FilePondPluginImageResize,
  FilePondPluginImagePreview
);

// Our app
class FileUploader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      files: [],
      uploading: false
    };
  }

  static defaultProps = {
    addFile: () => {},
    removeFile: () => {},
    onUploadComplete: () => {}
  };

  handleUpload = (
    fieldName,
    file,
    metadata,
    load,
    error,
    progress,
    abort,
    transfer,
    options
  ) => {
    const databaseRef = firebase.firestore().collection("files");
    const storageRef = firebase.storage().ref(this.props.path || "uploads");
    const task = storageRef.child(file.name).put(file);

    task.on(
      `state_changed`,
      snapshot => {
        progress(true, snapshot.bytesTransferred, snapshot.totalBytes);
      },
      error => {
        console.error(error.message);
        abort();
      },
      () => {
        //Success
        createPlaceholderFile("uploads");
        storageRef.child(file.name).updateMetadata({
          cacheControl: "public,max-age=31536000,no-cache" // one year
        });
        storageRef
          .child(file.name)
          .getMetadata()
          .then(metadata => {
            storageRef
              .child(file.name)
              .getDownloadURL()
              .then(url => {
                storageRef.child(file.name).updateMetadata({
                  cacheControl: "public,max-age=31536000,no-cache" // one year
                });
                const metaData = {
                  name: metadata.name,
                  size: metadata.size,
                  contentType: metadata.contentType,
                  fullPath: metadata.fullPath,
                  downloadURL: url
                };

                databaseRef.add(metaData).then(() => {
                  load();
                  this.props.addFile(metaData);
                  setTimeout(() => {
                    const remainingFiles = this.state.files.filter(
                      fileItem => fileItem.name !== file.name
                    );
                    this.setState({
                      files: remainingFiles,
                      uploading: Boolean(remainingFiles.length)
                    });

                    if (!remainingFiles.length && this.props.onUploadComplete) {
                      this.props.onUploadComplete();
                    }
                  }, 2000);
                });
              });
          });
      }
    );

    // Should expose an abort method so the request can be cancelled
    return {
      abort: () => {
        // This function is entered if the user has tapped the cancel button
        // request.abort();
        task.cancel();
        // Let FilePond know the request has been cancelled
        abort();
      }
    };
  };

  startUpload = () => {
    if (this.pond) {
      this.pond.processFiles();
    }
    this.setState({ uploading: true });
  };

  render() {
    return (
      <div>
        <AppBar position="sticky" color="default" elevation={1}>
          <Box textAlign="right" p={0.625}>
            {Boolean(this.state.files.length) && (
              <Button
                size="small"
                variant="text"
                onClick={this.pond ? () => this.pond.removeFiles() : undefined}
              >
                Remove All
              </Button>
            )}
            <Box display="inline" ml={1}>
              <Button
                size="small"
                variant="contained"
                color="primary"
                disabled={!this.state.files.length || this.state.uploading}
                onClick={this.startUpload}
              >
                Upload
              </Button>
            </Box>
          </Box>
        </AppBar>

        <FilePond
          dropOnPage={true}
          dropOnElement={false}
          ref={ref => (this.pond = ref)}
          files={this.state.files}
          // beforeDropFile={}
          // beforeAddFile={}
          allowMultiple={true}
          // allowImageResize={true}
          // imageResizeTargetWidth={50}
          // imagePreviewMaxHeight={100}
          // onremovefile={(error, file) => {}}
          instantUpload={false}
          maxParallelUploads={5}
          // maxFiles={3}
          server={{ process: this.handleUpload }}
          onupdatefiles={fileItems => {
            this.setState({
              files: fileItems.map(fileItem => fileItem.file)
            });
          }}
        />
      </div>
    );
  }
}

export default hot(module)(FileUploader);
